(function ($) {
    var masthead = $('#ecf-masthead');
    if(!masthead.length) return;

    // Load here
    // setBackground();
    // function setBackground() {
    //     var isMobile = window.matchMedia('(max-width: 767px)').matches;
    //     var background = masthead.data('bg');
    //     var targetBackground = isMobile ? '' : background;
    //     masthead.css('background-image', 'url(' + targetBackground + ')');
    // }

    // $(window).on('resize', function() {
    //     setBackground();
    // });

})(jQuery);